import moment from 'moment';
import React from 'react';
import timeLiveLogo from '../../assets/image/logo-Icon-timelive.svg'
import { useNavigate } from 'react-router-dom';

const ReminderToast = ({ closeToast, eventData }: any) => {
    const navigate = useNavigate();
    const start = moment(eventData.StartTime);
    const end = moment(eventData.EndTime);
    const duration = moment.duration(end.diff(start));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    let totalTime = '';
    if (hours > 0) {
        totalTime += `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    }
    if (minutes > 0) {
        if (totalTime) totalTime += ' ';
        totalTime += `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    }
    // const totalTime = `${hours} hour ${minutes} minute`;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }} onClick={() => navigate('/calendar')}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    alt="Logo"
                    src={timeLiveLogo}
                    width={20}
                    height={20}
                    style={{ position: 'relative', top: 0 }}
                />
                <span style={{ fontSize: '14px', color: '#1a1a1a' }}>
                    {/* TimeLive Calendar Reminder */}
                    Event Reminder
                </span>
            </div>
            <div style={{ fontSize: '14px', fontWeight: 600, color: '#1a1a1a', marginTop: '10px', lineHeight: 1.5 }}>
                {eventData?.EventName}
            </div>
            <div className="d-flex gap-1">
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#1a1a1a' }}>Duration: </span>
                <span style={{ fontSize: '12px', color: '#666' }}>{totalTime}</span>
            </div>
            <p style={{fontSize: '12px', color: '#666', lineHeight: 1.5 }}>
                {`Your event will start at ${moment(eventData?.StartTime).format('hh:mm A')}`}
            </p>
        </div>
    );
};

export default ReminderToast;
